// Routing/AppRoutes.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Layout from "../Layout";
import Home from "../Pages/Home";

import OnionPowder from "../Components/OnionPowder/OnionPowder";
import TomatoPowder from "../Components/TomatoPowder/TomatoPowder";
import BananaPowder from "../Components/BananaPowder/BananaPowder";
import TurmericPowder from "../Components/TurmericPowder/TurmericPowder";
import CocoPowder from "../Components/CocoPowder/CocoPowder";
import MaizePowder from "../Components/MaizePowder/MaizePowder";
import JowarPowder from "../Components/JowarPowder/JowarPowder";
import Categories from  "../Components/Categories/Categories"
import FeaturedProducts from "../Components/FeaturedProducts/FeaturedProducts"
import ResourcesSection from "../Components/ResourcesSection/ResourcesSection"
import PowderSlider from "../Components/PowderSlider/PowderSlider"
import ResourcesPage from "../Components/ResourcesPage/ResourcesPage"
import AboutSection from "../Components/AboutSection/AboutSection"

import ScrollToTop from "../Components/ScrollToTop";

const AppRoutes = () => {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/onion-powder" element={<OnionPowder />} />
          <Route path="/tomato-powder" element={<TomatoPowder />} />
          <Route path="/banana-powder" element={<BananaPowder />} />
          <Route path="/turmeric-powder" element={<TurmericPowder />} />
          <Route path="/coco-powder" element={<CocoPowder />} />
          <Route path="/maize-powder" element={<MaizePowder />} />
          <Route path="/jowar-powder" element={<JowarPowder />} />
          <Route path="/categories" element={<Categories />} />
           <Route path="/featuredproducts" element={<FeaturedProducts />} />
           <Route path="/ResourcesSection" element={<ResourcesSection />} />
           <Route path="/PowderSlider" element={<PowderSlider/>} />
            <Route path="/ResourcesPage" element={<ResourcesPage/>} />
              <Route path="/AboutSection" element={<AboutSection/>} />

         
        </Routes> 
      </Layout>
    </Router>
  );
};

export default AppRoutes;
